<template lang="pug">
    section#inscricao(:class="{'extensao': this.$route.name == 'jornada-de-extensao', 'cursosGratuitos': this.$route.name == 'cursos-gratuitos'}")
        div.wrapper
            h2.titulo {{ titulo }}
            h3.subtitulo {{ subtitulo }}
            form(@submit.prevent="sendFormulario", data-enviado="Cadastro enviado com sucesso. Você receberá instruções através do email.", :class="{ enviado }", v-if="hasForm").form#inscrevaseForm
                div.group
                    div.inputs(v-if="$route.name === 'jornada-de-extensao'")
                        input#inputInscNome(type="tel", placeholder="CPF", v-model="formulario.cpf", v-mask="'###.###.###-##'")
                        span.erro(v-if='errors.cpf') {{ errors.cpf[0] }}
                    div.inputs
                        input#inputInscNome(type="text", placeholder="Nome", v-model="formulario.nome")
                        span.erro(v-if='errors.nome') {{ errors.nome[0] }}
                    div.inputs
                        input#inputInscEmail(type="email", placeholder="E-mail", class="email", v-model="formulario.email")
                        span.erro(v-if='errors.email') {{ errors.email[0] }}
                    div.inputs
                        input#inputInscTelefone(type="tel", placeholder="Celular", class="telefone", v-model="formulario.celular", v-mask="'(##) #####-####'")
                        span.erro(v-if='errors.celular') {{ errors.celular[0] }}
                    div.inputs(v-if="$route.name === 'jornada-de-extensao' || $route.name === 'cursos-gratuitos'")
                        select#selectInscEstado(class="estado", v-model="formulario.uf", @change="toggleEstado(formulario.uf)")
                            option(:value="null", disabled) Estado
                            option(v-for="estado in estados", :value="estado.Id") {{ estado.Nome | getEstadoByUF(true) }}
                        span.erro(v-if='errors.uf') {{ errors.uf[0] }}
                    div.inputs(v-if="$route.name === 'jornada-de-extensao' || $route.name === 'cursos-gratuitos'")
                        select#selectInscCidade(class="cidade", v-model="formulario.cidade")
                            option(:value="null", disabled) Cidade
                            option(v-for="cidade in cidades", :value="cidade.nome") {{ cidade.nome }}
                        span.erro(v-if='errors.cidade') {{ errors.cidade[0] }}
                div.group
                    div.check
                        label(for="checkContatoWhatsapp")
                            span.labelTitle Podemos usar o WhatsApp e/ou SMS para falar sobre sua inscrição, matrícula e prestação de serviços?
                            input(type="checkbox", id="checkContatoWhatsapp", name="checkContatoWhatsapp", v-model="formulario.contato_whatsapp")
                            span Autorizo o uso do WhatsApp e/ou SMS no telefone informado.
                button(type="submit", v-html="buttonTextFormSaveContact", :disabled="disabled").button

</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: "component-inscricao",
    directives: {
        mask
    },
    props: {
        titulo: {
            default: "Inscreva-se e estude na UniFAEL"
        },
        subtitulo: {
            default: "Aproveite as oportunidades especiais de preço e matrícula."
        },
        hasForm: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        endpointURL() {
            if (this.$route.name === 'cursos-gratuitos')
                return 'contato/cursos-gratuitos'
            if (this.$route.name === 'jornada-de-extensao')
                return 'contato/jornada-extensao'
            return 'save-lead'
        }
    },
    async created() {
        if (this.$route.name === 'cursos-gratuitos' || this.$route.name === 'jornada-de-extensao')
            await this.loadEstados()
    },
    data() {
        return {
            formulario: {
                nome: '',
                email: '',
                celular: '',
                cpf: null,
                uf: null,
                cidade: null,
                contato_whatsapp: false,
                gclid: localStorage.getItem("gclid") || '',
            },
            estados: [],
            cidades: [],
            errors: {},
            disabled: false,
            enviado: false,
            buttonTextFormSaveContact: 'Enviar'
        }
    },
    methods: {
        sendFormulario() {
            this.disabled = true
            this.errors= {}
            this.buttonTextFormSaveContact = 'Enviando...'
            this.$leads
                .send(this.endpointURL, this.formulario)
                .then(() => {
                    this.enviado = true
                    this.buttonTextFormSaveContact = 'Enviado!'
                    this.formulario = Object.assign({}, {
                        nome: '',
                        email: '',
                        celular: '',
                        cpf: null,
                        uf: null,
                        cidade: null,
                        contato_whatsapp: false
                    })
                })
                .catch(error => {
                    this.errors = error.error_validate
                    this.buttonTextFormSaveContact = 'Tente novamente'
                })
                .finally(() => {
                    setTimeout(() => {
                        this.buttonTextFormSaveContact = 'Enviar'
                        this.disabled = false
                        this.enviado = false
                    }, 7500)
                })
        },
        async loadEstados() {
            return await this.$utils.getConcursoAtivo('pos')
                .then(concursoAtivo => this.$axios.get(`webservice/concurso/${concursoAtivo.Concurso}/ufs/`))
                .then(response => this.estados = response.data)
        },
        async loadCidades(uf) {
            return await this.$axios
                .get(`estados/${uf}/cidades/`)
                .then(response => this.cidades = response.data)
        },
        async toggleEstado(uf) {
            this.formulario.cidade = null
            this.cidades = []
            await this.loadCidades(uf)
        }
    },
}
</script>

<style lang="stylus" scoped src="./Inscricao.styl"></style>
